import { LogBuilder } from '@sgme/logger';

import { appConfig, applicationPrefix, isProductionEnv } from 'app/app.config';
import { sgwtConnect } from 'common/sgwt/sgwtConnect';

// oxlint-disable-next-line new-cap ✔️
const logBuilder = LogBuilder()
  .enableServerLogs({ url: `${appConfig.api_uri}/log`, prefix: `[${applicationPrefix}]`, storeName: 'main' })
  .setAuthTokenFactory(() => {
    if (sgwtConnect.isAuthorized()) {
      const authToken = sgwtConnect.getAuthorizationHeader();

      if (authToken) {
        return authToken;
      }
    }

    // TODO: test in reality if this error is properly handled by front core
    throw new Error('No authorization header or token. Disconnected ?!');
  });

if (!isProductionEnv) {
  logBuilder.enableConsole();
}

export const logger = logBuilder.build();

export function onUserConnected(): void {
  logger.resumeServerLogs();
}

export function onUserDisconnected(): void {
  logger.pauseServerLogs();
}
